module.exports = {"title":"in B flat","date":"2012-09-30T05:46:07.000Z","layout":"post","category":"music art cool","description":"random thing I found","body":"<p>check out <a href=\"http://inbflat.net\">inbflat</a> for about an hours worth of profundity.</p>\n"}


/*****************
 ** WEBPACK FOOTER
 ** ./articles/2012-09-30-in-b-flat/index.md
 ** module id = 472
 ** module chunks = 0
 **/